import React, { createContext, useContext } from 'react';

export const TicketContext = createContext();

export const useTickets = () => useContext(TicketContext);
